<template>
	<div class="layout-footer-mobile-wrap">
		<div class="contactInformation">
			<div class="contactInformation-top">
				<img src="@/assets/images/mini_logo.png" alt="" />
			</div>
			<div class="contactInformation-main">
				<div class="mainBox">
					<span class="mainBox-title">{{ $t('contact.address') }}</span>
					<span class="mainBox-test">{{ $t('contact.address_content') }}</span>
				</div>
				<div class="mainBox">
					<span class="mainBox-title">{{ $t('contact.email') }}</span>
					<span class="mainBox-test">info@aidite.com</span>
				</div>
				<div class="mainBoxList">
					<div class="mainBox">
						<span class="mainBox-title">{{ $t('contact.fax') }}</span>
						<span class="mainBox-test">0335-8587198</span>
					</div>
					<div class="mainBox">
						<span class="mainBox-title">{{ $t('contact.phone') }}</span>
						<span class="mainBox-test">400-003-1233</span>
					</div>
				</div>
			</div>
			<div class="erweimaList">
				<div class="erweimaBox">
					<img src="@/assets/images/qrcode.jpg" alt="" />
					<span>Aidite官网</span>
				</div>
				<div class="erweimaBox">
					<img src="@/assets/images/qrcode_02.jpg" alt="" />
					<span>Aidite技工</span>
				</div>
				<div class="erweimaBox">
					<img src="@/assets/images/qrcode_03.jpg" alt="" />
					<span>Aidite椅旁</span>
				</div>
				<div class="erweimaBox">
					<img src="@/assets/images/qrcode_miniapp.png" alt="" />
					<span>爱迪特投关</span>
				</div>
			</div>
			<div class="imgBox">
				<div
					v-for="(item, index) in footerIcons"
					:key="index"
					class="faceBook"
					@click="actionFooterIcon(item.link)"
				>
					<img :src="item.icon" alt="" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';

const footerIcons = ref([
	{
		icon: require('@/assets/images/footer/footer_01.png'),
		link: 'https://www.xiaohongshu.com/user/profile/612446cb0000000001005a4a?xhsshare=CopyLink&appuid=5fc86728000000000101fca2&apptime=1712805199&exSource=https://mp.weixin.qq.com/'
	},
	{
		icon: require('@/assets/images/footer/footer_02.png'),
		link: 'https://weibo.com/aiditeyake'
	},
	{
		icon: require('@/assets/images/footer/footer_03.png'),
		link: 'https://www.zhihu.com/org/ai-di-te-kou-qiang'
	},
	{
		icon: require('@/assets/images/footer/footer_04.png'),
		link: 'https://baijiahao.baidu.com/u?app_id=1676600919556388'
	},
	{
		icon: require('@/assets/images/footer/footer_05.png'),
		link: 'https://www.zhaopin.com/companydetail/CZ599187620.htm?refcode=4019&srccode=401901&preactionid=73093a68-e7c5-4fce-bbd0-fdb610a797a6'
	}
]);
const actionFooterIcon = link => {
	window.open(link);
};
</script>

<style lang="less" scoped>
.layout-footer-mobile-wrap {
	padding: 2.6rem 2.1rem 3.5rem;
	background-color: #f9fcfd;

	.contactInformation-top {
		margin-bottom: 3rem;

		img {
			width: 6rem;
			height: 1.5rem;
		}
	}

	.mainBox {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		margin-bottom: 2.85rem;

		.mainBox-title {
			font-size: 1.5rem;
			font-family: 'SourceHanSansCN-Medium';
			color: #000;
			margin-bottom: 1rem;
		}
		.mainBox-test {
			font-size: 1.5rem;
			font-family: 'SourceHanSansCN-Regular';
			color: #5d5d5f;
		}
	}

	.mainBoxList {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
	}

	.erweimaList {
		padding: 0 4.6rem;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 1.42rem;

		.erweimaBox {
			text-align: center;
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-ms-flex-direction: column;
			flex-direction: column;

			&:last-child {
				margin-right: 0;
			}
			img {
				display: block;
				width: 100%;
				margin-bottom: 1rem;
			}
			span {
				font-size: 1.1rem;
				font-family: 'SourceHanSansCN-Regular';
				color: #5d5d5f;
			}
		}
	}

	.imgBox {
		margin-top: 3.5rem;
		padding: 0 1.3rem;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;

		img {
			display: block;
			width: 3.7rem;
			height: 3.75rem;
		}
	}
	.faceBook {
		height: 3.75rem;
		width: 3.75rem;
	}
}
</style>
